<style lang="less" scoped>
  .dialogBox { position: relative;
    .imgview_close { position: fixed; width: 32px; height: 32px; text-align: center; line-height: 32px;
      font-size: 14px; right: 16px; top: 16px; cursor: pointer; font-size: 24px; color: #666; z-index: 102;
      background: #fff; border: 2px solid #e5e7ea; border-radius: 4px}
    .dialogBg{ position: fixed; top: 0; right: 0; left: 0; bottom: 0; z-index: 101; background: rgba(0,0,0,.3);}
    .imgview_box { width:800px; height: 600px; position: fixed; z-index: 102;left: 50%; top: 50%; margin: -300px 0 0 -400px;
      .imgview { position: relative; width: 100%; height: 100%;
        .imgview_info{
          >img{ border-radius: 4px; border:2px solid #eeeeee; box-shadow: 0 0 10px rgba(0,0,0,.8); }
        }
        .arrLeft,.arrRight{ position: fixed; width: 50px; height: 50px; cursor: pointer;
          top: 50%; margin-top:-25px; text-align: center;
            i{ background: none; padding: 0 8px; color: #fff; font-size: 48px;
              &:hover{ background: #fff; color: #666;}
              &:active{ color: #2babee; }
            }
          }
        .arrLeft{ left: 100px; }
        .arrRight{ right: 100px; }
        .preview{ position: fixed; height: 70px; bottom: 24px; left: 0;  right: 0;
          .previewBox{ width: 650px; position: relative; padding: 0 24px; height: 70px; text-align: center; margin: auto; overflow: hidden; white-space: nowrap;
            .preBox{ transition: 0.3s all; padding: 0 4px;
              .perviewImgs{ height: 66px; width: 68px; margin-right:4px; display:inline-block; background: #fff;
                  border:2px solid rgba(0,0,0,0);  text-align:justify;
                  text-align-last:justify;
                img{ width: 100%; height: 66px; cursor: pointer; }
              }
              .active{ border:2px solid #2babee; }
            }
            .previewBox_left,.previewBox_right{ position: absolute; cursor: pointer; background: #fff;  top: 0;
                bottom: 0; height: 70px; line-height: 80px;
              i{padding: 0 8px; color: #666; font-size: 24px;
                &:hover{ color: #333; }
                &:active{ color: #2babee; }
              }
            }
            .previewBox_left{ left: 0; border-right: 1px solid #e5e7ea;}
            .previewBox_right{ right: 0; border-left: 1px solid #e5e7ea;}
          }
        }
        .title_name{ position: fixed;left:0; right:0; height: 40px; bottom: 102px; text-align: center; background: rgba(0,0,0,.3); color:#fff; font-size: 18px; line-height: 40px; }
      }
    }
    // .media_info{ position: fixed; width:800px; height: 450px; background: #fff; z-index: 102; top: 50%; left: 50%;
    //   margin-left: -400px; margin-top: -200px; border-radius: 4px; border: 2px solid #e5e7ea;
    //   .media_box { position: relative; width: 800px; height: 450px; padding: 8px; box-sizing: border-box;
    //     .media_close { position: absolute; border: 2px solid #e5e7ea; background: #fff; border-left: none; width: 32px; height: 32px;
    //       text-align: center; line-height: 32px; font-size: 14px; right: -34px; border-radius: 0 4px 4px 0; top: 16px; cursor: pointer; }
    //     .media_audio{ height: 400px; width: 100%; background: #e5e7ea; line-height: 80px; text-align: center;
    //       img{ width: 260px; height: 260px; margin-top: 70px; border-radius: 150px;}
    //     }
    //     >div{
    //       >audio{ width: 100%; }
    //     }
    //     .media_video,.media_file{ width: 100%; height: 100%; background: #e5e7ea; }
    //     .media_video{
    //       .video_box{ width: 100%; height: 434px;}
    //     }
    //   }
    // }
  }
  .isOpacity{
    opacity: 1;
  }
</style>
<template>
  <div class="dialogBox">
    <div class="dialogBg" @click="closeImg"></div>
    <div class="imgview_close"><i class="el-icon-close" @click="closeImg"></i></div>
    <!-- 图片查看 -->
    <div class="imgview_box">
      <div class="imgview" :class="[isOpacity ? '' : 'isOpacity']">
        <div class="title_name" v-if="showImgName">{{imgTitle_name}}</div>
        <div class="imgview_info" >
          <img :src="imageUrl+srcImg" :style="styleImg"/>
        </div>
        <div v-if="mulits.imgsrcs.length > 1">
          <div class="arrLeft" @click="pre" v-if="isPre">
            <i class="fa fa-angle-left"></i>
          </div>
          <div class="arrRight" @click="next" v-if="isNext">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
        <div class="preview" v-if="mulits.imgsrcs.length > 1">
          <div class="previewBox">
            <div class="preBox" :style="{marginLeft: mgLeft+'px'}">
              <div class="perviewImgs" v-for="(i,index) in mulits.imgsrcs" :key="index"
                :class=" imgIndex == index ? 'active':''  "
                @click="perImg(i,index)">
                <img :src="imageUrl+i[imgId]" >
              </div>
            </div>
            <div v-if="mulits.imgsrcs.length > 8">
              <div class="previewBox_left" @click="preLeft">
                <i class="fa fa-angle-left"></i>
              </div>
              <div class="previewBox_right" @click="preRight">
                <i class="fa fa-angle-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props:{
      imgsrc:{type:Array, default(){}},//图片数组
      typeCode:{type:Number},
      imgId:{type:String,default(){ return "imgId" }},
      imgName:{type:String,default(){ return "imgName" }},
      imgTitle:{type:String,default(){ return "imgName" }},
      showImgName:{type:Object,default(){ return true }},//是否显示图片名
      defaultImg:{type:Object,default(){}},//展示大图的id与图组图片下标一致
    },
    data(){
      return{
        //图片显示地址
        imageUrl: window.systemParameter.FILE_SYSTEM_URL + "/api/image/thumbnail/",
        imgWidth:'', //图片宽度
        imgHight:'', //图片高度
        windWidth:document.documentElement.clientWidth,//获取视口宽度
        windHeight:document.documentElement.clientHeight,//获取视口高度
        srcImg: '',//默认展示第一张大图的图片地址
        imgIndex: null,
        isPre:true,
        isNext:true,
        imgTitle_name:'',
        styleImg:{
          width:'800px',
          hight:'600px',
          marginLeft:'',
          marginTop:'',
        },
        mulits:{
          imgsrcs:[],
        },
        mgLeft:0,
        isOpacity: false,
      }
    },
    mounted(){
      let vm = this
      vm.play()
      console.log(111111,vm.imgId)
      setTimeout(_=>{
        vm.isOpacity = true
        vm.imgBox()
      },2000)
    },
    methods:{
      play(){
        let vm = this
        vm.imgTitle_name = _.cloneDeep(vm.imgTitle)
        vm.mulits.imgsrcs = _.cloneDeep(vm.imgsrc)
        vm.imgIndex = vm.defaultImg.imgIndex//默认选中index
        vm.srcImg = vm.defaultImg.imgId//默认选中图片地址
        vm.imgBox(vm.srcImg)//传入图片盒子判断自适应图片居中
        if(vm.imgIndex<=0){
          vm.isPre = false
        }else if(vm.imgIndex>=vm.mulits.imgsrcs.length-1){
          vm.isNext = false
        }
      },
      closeImg(){//关闭功能
        this.$emit('closeBox')
      },
      next(){
        let vm = this
        vm.imgIndex++
        if(vm.imgIndex>0){
          vm.isPre = true
        }
        for(let i=0;i<vm.mulits.imgsrcs.length;i++ ){
          if( vm.imgIndex == i ){ //当imgId与i相同时改变图片地址切换图片
            vm.srcImg = vm.mulits.imgsrcs[i][vm.imgId]
            vm.imgTitle_name = vm.mulits.imgsrcs[i][vm.imgName]
          }
        }
        vm.imgBox(vm.srcImg)//每次切换图片都将图片地址传入图片盒子判断自适应
        if(vm.imgIndex >= vm.mulits.imgsrcs.length-1){//超过长度将图片数组长度赋给imgId
          vm.imgIndex = vm.mulits.imgsrcs.length-1
          vm.isNext = false
        }
      },
      pre(){
        let vm = this
        vm.imgIndex--
        for(let i=0;i<vm.mulits.imgsrcs.length;i++ ){
          if( vm.imgIndex == i ){
            vm.srcImg = vm.mulits.imgsrcs[i][vm.imgId]
            vm.imgTitle_name = vm.mulits.imgsrcs[i][vm.imgName]
          }
        }
        vm.imgBox(vm.srcImg)
        if(vm.imgIndex <= 0){
          vm.imgIndex = 0
          vm.isPre = false
        }
        if(vm.imgIndex < vm.mulits.imgsrcs.length-1){
          vm.isNext = true
        }
      },
      perImg(i,index){
        let vm = this
        vm.imgIndex = index
        vm.srcImg = i[vm.imgId]
        vm.imgTitle_name = i[vm.imgName]
       //默认选中图片地址
        vm.imgBox(i[vm.imgId])
      },
      preLeft(){
        let vm = this
        if( vm.mgLeft == 0){
          vm.mgLeft = 0
        }else{
          vm.mgLeft += 70
        }
      },
      preRight(){
        let vm = this
        if( vm.mgLeft <= -vm.mulits.imgsrcs.length * 70){
          vm.mgLeft = -vm.mulits.imgsrcs.length * 70
        }else{
          vm.mgLeft = vm.mgLeft - 70
        }
      },
      imgBox(imgsSrc){
        let vm = this
        let img = new Image()
        img.src = vm.imageUrl + imgsSrc
        img.onload = e =>  {
          console.log(img.width,img.height)
          let n = img.width/800
          let m = img.height/600
          setTimeout(_=>{
            if(img.height < 600 && img.width < 800){
              vm.styleImg.height = img.height+'px'
              vm.styleImg.width = img.width+'px'
              vm.styleImg.marginLeft = (800-img.width)/2+'px'
              vm.styleImg.marginTop = (600-img.height)/2+'px'
            }
            if(img.width>img.height){
              if( img.width >= 800 ){
                vm.styleImg.width = 800+'px'
                vm.styleImg.height = img.height/n+'px'
                vm.styleImg.marginLeft = 0
                vm.styleImg.marginTop = (600-img.height/n)/2+'px'
              }
            }else if(img.width<img.height){
              if( img.height >= 600 ){
                vm.styleImg.height = 600+'px'
                vm.styleImg.width = img.width/m+'px'
                vm.styleImg.marginTop = 0
                vm.styleImg.marginLeft = (800-img.width/m)/2+'px'
              }
            }
          },500)

        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/commonplugin/common/comm_mulit_media.vue